import { render, staticRenderFns } from "./sinak.vue?vue&type=template&id=59808b29&scoped=true&"
import script from "./sinak.vue?vue&type=script&lang=js&"
export * from "./sinak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59808b29",
  null
  
)

export default component.exports